import type { ComponentProps } from 'react'

// Full class names so Tailwind can see them.
const widths = {
  site: 'max-w-site',
  wide: 'max-w-[1010px]',
  narrow: 'max-w-[940px]',
  form: 'max-w-[650px]',
}

/**
 * Site-wide content wrapper: 90% wide, centered, capped by `width` (default
 * `site`, 1320px). One-off widths can still pass a `max-w-*` class, which
 * replaces the preset.
 */
export function Container({
  className = '',
  width = 'site',
  ...props
}: ComponentProps<'div'> & { width?: keyof typeof widths }) {
  const maxWidth = /(^|\s)max-w-/.test(className) ? '' : widths[width]
  return (
    <div
      className={`relative mx-auto w-[90%] ${maxWidth} ${className}`}
      {...props}
    />
  )
}
